import { defineTemplate } from 'src/utils';
import { PAYMENT_METHOD_HIGHLIGHT_VARIANTS } from '../_shared/pills/payment-method-highlight-variants';
import { macroAhorroDoble1080x1920 } from './layouts/Ahorro-1080x1920';
import { BRANDS } from '../_shared/data/brands';
import { CATEGORY_OPTIONS } from '../_shared/data/category-options';
import { BRAND_LOGOS_MAX } from '../_shared/images/brand-logos';
import { PAYMENT_METHOD_TEXT_OPTIONS } from '../_shared/data/payment-method-options';
import { LEGALES_OPTIONS } from '../_shared/data/legales-options';
import { MACRO_MEDIA_BASE } from '../_shared/data/media';
import { WALLETS_OPTIONS } from '../_shared/data/wallets-options';

const THUMB = `${MACRO_MEDIA_BASE}/templates/ahorro-doble/thumbnails/macro-ahorro-doble.png`;

export const macroAhorroDoble = defineTemplate({
  mode: 'wysiwyg',
  id: 'macro-ahorro-doble',
  clientId: 'MACRO',
  handlerKey: 'MACRO',
  title: 'Ahorro Doble',
  thumbnail: { url: THUMB, optimizedUrl: THUMB, aspectRatio: 'vertical' },
  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'category',
      label: 'Categoría',
      type: 'select',
      required: true,
      defaultValue: 'GASTRONOMÍA',
      placeholder: 'Selecciona una categoría',
      options: CATEGORY_OPTIONS
    },
    {
      key: 'valid-days',
      label: 'Días de validez',
      type: 'input',
      placeholder: 'Ejemplo: Lunes a viernes',
      required: true,
      defaultValue: 'Todos los días'
    },
    {
      key: 'discount-value-a',
      label: 'Texto del descuento 1',
      type: 'number',
      placeholder: 'Ejemplo: 20%',
      required: true,
      defaultValue: 10
    },
    {
      key: 'discount-value-b',
      label: 'Texto del descuento 2',
      type: 'number',
      placeholder: 'Ejemplo: 20%',
      required: true,
      defaultValue: 20
    },
    {
      key: 'benefit-label-a',
      label: 'Beneficio 1',
      type: 'input',
      placeholder: 'de descuento, de 2x1, etc.',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'benefit-label-b',
      label: 'Beneficio 2',
      type: 'input',
      placeholder: 'de descuento, de 2x1, etc.',
      required: true,
      defaultValue: 'de ahorro'
    },
    {
      key: 'payment-method-text-a',
      label: 'Mensaje principal 1',
      type: 'input',
      placeholder: 'Con todas tus Tarjetas de Crédito Macro',
      required: true,
      defaultValue: 'Con todas tus Tarjetas de Crédito Macro',
      options: PAYMENT_METHOD_TEXT_OPTIONS
    },
    {
      key: 'payment-method-text-b',
      label: 'Mensaje principal 2',
      type: 'input',
      placeholder: 'Con todas tus Tarjetas de Crédito Macro',
      required: true,
      defaultValue: 'Con todas tus Tarjetas de Crédito Macro',
      options: PAYMENT_METHOD_TEXT_OPTIONS
    },
    {
      key: 'limit-text-a',
      label: 'Texto del tope 1',
      type: 'input',
      multiline: true,
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: 'Tope $10.000 por cliente, por semana.'
    },
    {
      key: 'limit-text-b',
      label: 'Texto del tope 2',
      type: 'input',
      multiline: true,
      placeholder: 'Ejemplo: Hasta agotar stock',
      required: true,
      defaultValue: 'Tope $10.000 por cliente, por semana.'
    },
    {
      key: 'payment-method-highlight',
      label: 'Mensaje adicional',
      type: 'polymorphic',
      required: true,
      defaultVariant: 'text',
      variants: [
        {
          key: 'text',
          label: 'Texto libre',
          fields: [
            {
              key: 'value',
              label: 'Mensaje',
              type: 'input',
              placeholder: 'Pagando con tu celular sin contacto',
              required: true,
              defaultValue: 'Pagando con tu celular sin contacto'
            }
          ]
        },
        {
          key: 'pill-pair',
          label: 'Doble pill',
          fields: [
            {
              key: 'left',
              label: 'Pill izquierda',
              type: 'input',
              placeholder: 'Exclusivo con',
              required: true,
              defaultValue: 'Exclusivo con'
            },
            {
              key: 'right',
              label: 'Pill derecha',
              type: 'input',
              placeholder: 'desde App',
              required: true,
              defaultValue: 'desde App'
            }
          ]
        },
        {
          key: 'pill-pair-inv',
          label: 'Doble pill (invertida)',
          fields: [
            {
              key: 'left-inv',
              label: 'Pill izquierda',
              type: 'input',
              placeholder: 'Pagá con',
              required: true,
              defaultValue: 'Pagá con'
            },
            {
              key: 'right-inv',
              label: 'Pill derecha',
              type: 'input',
              placeholder: 'desde App',
              required: true,
              defaultValue: 'desde App'
            }
          ]
        }
      ]
    },
    {
      key: 'wallets-enabled',
      label: 'Billeteras digitales',
      type: 'image-multi-select',
      required: false,
      defaultValue: [],
      options: WALLETS_OPTIONS
    },
    {
      key: 'legales',
      label: 'Legales',
      type: 'input',
      placeholder: 'CARTERA CONSUMO',
      required: false,
      options: LEGALES_OPTIONS
    },
    {
      key: 'background-image',
      label: 'Imagen de fondo',
      type: 'image',
      required: false
    },
    {
      key: 'brand-logos',
      label: 'Logos de marcas',
      type: 'image-multi-select',
      required: false,
      defaultValue: [],
      maxSelections: BRAND_LOGOS_MAX,
      options: BRANDS.map(b => ({
        value: b.value,
        label: b.label,
        imageUrl: b.imageUrl
      }))
    }
  ],
  canvasBinding: {
    resolutions: [
      {
        id: '1080x1920',
        label: '1080×1920',
        canvasWidth: 1080,
        canvasHeight: 1920,
        type: 'image',
        layout: macroAhorroDoble1080x1920
      }
    ],

    fieldBindings: [
      { kind: 'simple', fieldKey: 'category', pieceId: 'category', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'valid-days', pieceId: 'valid-days', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value-a', pieceId: 'discount-value-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'discount-value-b', pieceId: 'discount-value-b', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label-a', pieceId: 'benefit-label-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'benefit-label-b', pieceId: 'benefit-label-b', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'limit-text-a', pieceId: 'limit-text-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'limit-text-b', pieceId: 'limit-text-b', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text-a', pieceId: 'payment-method-text-a', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'payment-method-text-b', pieceId: 'payment-method-text-b', bindingType: 'text' },
      { kind: 'simple', fieldKey: 'wallets-enabled', pieceId: 'wallets', bindingType: 'group-collection' },
      {
        kind: 'polymorphic',
        fieldKey: 'payment-method-highlight',
        defaultVariant: 'text',
        variants: PAYMENT_METHOD_HIGHLIGHT_VARIANTS,
        positionsByResolution: {
          '1080x1920': {
            'payment-method-highlight-text': { top: 1290.7627 },
            'payment-method-highlight-pair': { top: 1145.7627 },
            'payment-method-highlight-pair-inv': { top: 1145.7627 }
          }
        }
      },
      { kind: 'simple', fieldKey: 'background-image', pieceId: 'background-image', bindingType: 'image-replace' },
      { kind: 'simple', fieldKey: 'brand-logos', pieceId: 'brand-logos', bindingType: 'group-collection' }
    ]
  }
});
